import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import z from "zod";

// src/models/classInstanceCustomerNotice.ts
const CLASS_INSTANCE_CUSTOMER_NOTICE_CHANGE_TYPE = {
	CANCELLED: "cancelled",
	UPDATED: "updated"
};
const classInstanceCustomerNoticeChangeTypeSchema = z.enum([CLASS_INSTANCE_CUSTOMER_NOTICE_CHANGE_TYPE.CANCELLED, CLASS_INSTANCE_CUSTOMER_NOTICE_CHANGE_TYPE.UPDATED]);
const classInstanceCustomerNoticeChangedFieldSchema = z.enum([
	"classStartTimeUtc",
	"classDurationMinutes",
	"instructorId"
]);
const classInstanceCustomerNoticePreviousValuesSchema = z.object({
	classStartTimeUtc: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date()).optional(),
	classDurationMinutes: z.number().optional(),
	instructorId: zodFlavorId().optional(),
	instructorName: meta(z.string().optional(), { pii: { category: "name" } })
});
const classInstanceCustomerNoticeSchema = z.object({
	id: zodFlavorId(),
	classInstanceId: zodFlavorId(),
	classId: zodFlavorId(),
	classScheduleId: zodFlavorId().nullable().optional(),
	changeType: classInstanceCustomerNoticeChangeTypeSchema,
	classStartTimeUtc: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date()),
	classDurationMinutes: z.number(),
	instructorId: zodFlavorId(),
	className: z.string(),
	instructorName: meta(z.string(), { pii: { category: "name" } }),
	previousValues: classInstanceCustomerNoticePreviousValuesSchema.optional(),
	changedFields: z.array(classInstanceCustomerNoticeChangedFieldSchema).optional(),
	customerMessage: meta(z.string().max(500).optional(), { pii: { category: "freeText" } }),
	createdAt: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date()),
	updatedAt: z.any().transform(zodTransformFirestoreTimestampToDate).pipe(z.date())
});
const ClassInstanceCustomerNotices = defineFirestoreCollection("class_instance_customer_notices", classInstanceCustomerNoticeSchema, void 0, {
	dwReplication: false,
	firestoreCollectionPath: "class_instance_customer_notices"
});

export { CLASS_INSTANCE_CUSTOMER_NOTICE_CHANGE_TYPE, ClassInstanceCustomerNotices, classInstanceCustomerNoticeChangeTypeSchema, classInstanceCustomerNoticeChangedFieldSchema, classInstanceCustomerNoticePreviousValuesSchema, classInstanceCustomerNoticeSchema };
//# sourceMappingURL=classInstanceCustomerNotice.mjs.map